import React, { createContext } from 'react'
import * as firebase from '../firebase'

export const FireBaseContext = createContext()

export const FireBaseProvider = ({ children }) => {
  return (
    <FireBaseContext.Provider value={firebase}>
      {children}
    </FireBaseContext.Provider>
  )
}
